import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedHelper } from "../GeneratedClasses/GeneratedHelper" // GENERATED

export class Helper extends GeneratedHelper {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    const data = {
      id: this.id,
      posX: this.getX(),
      posY: this.getY(),
      direction: this.getDirection(),
    }
    gameInstance.SendMessage("GridManager", "CreateHelperPlethora", JSON.stringify(data))
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    gameInstance.SendMessage("GridManager", "DestroyHunterOrHelper", this.id)
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onDirectionUpdate(
    newValue: DataTypeDirection,
    oldValue: DataTypeDirection,
    uiData: UiData
  ): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnHelperDirectionUpdate", newValue)
  }

  protected onXUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onYUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnDown(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HelperRotateToFromPlethora", "down")
  }

  protected onTurnUp(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HelperRotateToFromPlethora", "up")
  }

  protected onTurnRight(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HelperRotateToFromPlethora", "right")
  }

  protected onTurnLeft(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HelperRotateToFromPlethora", "left")
  }

  protected onStep1(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnHelperStep", 1)
  }

  protected onStep3(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnHelperStep", 3)
  }

  protected onStep2(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnHelperStep", 2)
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMeets(isActivator: boolean, otherEntity: AbstractEntity, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
